import React, { useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import DelBox from '../comps/DelBox';
import AddMedicine from '../models/AddMedicine';
import AppConst from "../apis/appconst";
import axios from "axios";
import Swal from "sweetalert2";

const Medicines = () => {
  const [formData, setFormData] = useState({
    l1: [], // full list of medicines (fetched all)
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);

  // Fetch all medicines (page_no = "none")
  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    if (!storedData) return;
    const parsedUser = JSON.parse(storedData);
    setLdata(parsedUser);
    const roleId = parsedUser?.role_id;
    setIsAdmin(roleId === 1 || roleId === "1");

    const fd = new FormData();
    fd.append('page_no', "none"); // fetch all rows
    fd.append('search_key', ""); // unused by backend
    fd.append('med_user', "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getMedListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data && response.data.status) {
        const records = response.data.records || [];
        setFormData(prev => ({ ...prev, l1: records }));
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
      }
    } catch (err) {
      console.error("initData error", err);
      setFormData(prev => ({ ...prev, l1: [] }));
    }
  };

  useEffect(() => {
    initData();
    // eslint-disable-next-line
  }, []);

  // Delete item
  const delItem = async (item) => {
    if (!item) return;
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete medicine "${item.med_name}"? This cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete',
      cancelButtonText: 'Cancel',
    });
    if (!result.isConfirmed) return;

    try {
      const fd = new FormData();
      fd.append('med_id', item.med_id + "");
      const response = await axios.post(AppConst.BASE_URL + AppConst.delMedUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status) {
        await initData();
        Swal.fire({ icon: 'success', title: 'Deleted', timer: 1200, showConfirmButton: false });
      } else {
        Swal.fire({ icon: 'error', title: 'Delete failed', text: response.data?.success || 'Server error' });
      }
    } catch (err) {
      console.error("delItem error", err);
      Swal.fire({ icon: 'error', title: 'Delete failed', text: String(err?.message || err) });
    }
  };

  const handleAddDepart = async () => {
    // re-fetch all after add/update
    await initData();
  };

  // columns for react-data-table-component
  const columns = useMemo(() => [
    {
      name: '',
      cell: (row, index) => index + 1,
      width: '60px',
      sortable: false,
    },
    {
      name: 'Medicine Name',
      selector: row => row.med_name || '-',
      sortable: true,
      grow: 3,
    },
    {
      name: 'Medicine in Strip',
      selector: row => row.med_in_strips || '-',
      sortable: true,
      grow: 2,
    },
    {
      name: 'Category',
      selector: row => row.cat_name || '-',
      sortable: true,
    },

    {
      name: 'Unit',
      selector: row => row.med_unit_name || row.med_select_unit || '-',
      sortable: true,
      grow: 1,
    },
    
    

    {
      name: 'Hsn Code',
      selector: row => row.med_hsn_code || '-',
      sortable: true,
    },
    {
      name: 'GST',
      selector: row => (row.med_comp_name ? row.med_comp_name + '%' : '-'),
      sortable: true,
    },
    
    {
      name: 'Action',
      cell: (row) => (
        <ul className="list-inline hstack gap-2 mb-0" style={{ margin: 0, padding: 0 }}>
          <li className="list-inline-item edit">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary d-inline-flex align-items-center edit-item-btn"
              // disabled={!isAdmin}
              // style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? 'none' : 'auto' }}
              onClick={(e) => {
                e.preventDefault();
                setEditItem(row);
                // open modal (existing hidden button)
                const btn = document.getElementById('addbt453');
                if (btn) btn.click();
              }}
            >
              <i className="ri-pencil-fill fs-16 me-1"></i> Edit
            </button>
          </li>

          <li className="list-inline-item">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger d-inline-flex align-items-center remove-item-btn"
              disabled={!isAdmin}
              style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? 'none' : 'auto' }}
              onClick={(e) => { e.preventDefault(); delItem(row); }}
            >
              <i className="ri-delete-bin-5-fill fs-16 me-1"></i> Delete
            </button>
          </li>
        </ul>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '220px',
    }
  ], [isAdmin]);

  // filtered data based on search_key
  const filteredData = useMemo(() => {
    const key = (formData.search_key || '').toLowerCase().trim();
    if (!key) return formData.l1 || [];
    return (formData.l1 || []).filter(item => (
      (item.med_name || '').toLowerCase().includes(key) ||
      (item.cat_name || '').toLowerCase().includes(key) ||
      (item.med_hsn_code || '').toLowerCase().includes(key)
    ));
  }, [formData.l1, formData.search_key]);
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',      // larger header text
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px', // row font size
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',      // larger body text
        lineHeight: '20px'
      }
    },
  };
  return (
    <div className="page-content">
      <div className="container-fluid">

        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Medicines</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <button id="addbt453" style={{ display: "none" }} type="button" className="btn btn-success add-btn" data-bs-toggle="modal" data-bs-target="#addMedicineModal"></button>
                      <button type="button" className="btn btn-success add-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setEditItem(null);
                          document.getElementById("addbt453").click();
                        }}
                      >
                        <i className="ri-add-line align-bottom me-1"></i> Add Medicine </button>
                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-xxl-5 col-sm-6">
                      <div className="search-box">
                        <input className="form-control search" name="search_key" onChange={(e) => setFormData(prev => ({ ...prev, search_key: e.target.value }))} value={formData.search_key} placeholder="Search by name" type="text" />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <br />
              <div className="card-body pt-0">
                <div>
                  <div className="table-responsive table-card mb-1">
                    <DataTable
                      columns={columns}
                      data={filteredData}
                      selectableRows={true}
                      persistTableHead
                      pagination
                      paginationPerPage={10}
                      paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
                      highlightOnHover
                      noHeader
                      defaultSortFieldId={2}
                      customStyles={customStyles}
                      responsive
                      dense={false}
                      // customStyles can be added here if you like
                    />
                  </div>

                  
                </div>

                <AddMedicine item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Medicines;
